module.exports = __webpack_public_path__ + "static/media/octopus.6a85081b.png";